export default function identity<T>(a: T) {
  return a
}
